module.exports = __webpack_public_path__ + "img/ion_filter.535ee707.svg";